import Fit from './Fit.js';
export { Fit };
export default Fit;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-fit/dist/esm/index.js
// module id = 1791
// module chunks = 7